<script setup>
import { GM_IMAGES, u } from '@/data/images';
import CountUp from '@/components/ui/CountUp.vue';
import vReveal from '@/directives/reveal';
import silhouette from '@/assets/brand/silhouette-savanna.png';

const bgImage = `url(${u(GM_IMAGES.acaciaSunset, 1600)})`;

const STATS = [
  { to: 8, suffix: '', label: 'Destinations' },
  { to: 12, suffix: '', label: 'Travel Services' },
  { to: 4, suffix: '', label: 'Signature Itineraries' },
  { to: 100, suffix: '%', label: 'Tailor-Made' },
];
</script>

<template>
  <section class="whyus" id="why-us">
    <div class="whyus__bg" :style="{ backgroundImage: bgImage }" />
    <img class="whyus__silhouette" :src="silhouette" alt="" aria-hidden="true" />
    <div class="wrap">
      <div class="section-head" v-reveal>
        <span class="eyebrow eyebrow--light">Why Choose Us</span>
        <h2 style="color: #fff;">Local roots. World-class journeys.</h2>
        <p style="color: rgba(247,240,230,.82);">
          Born in Arusha at the foot of Kilimanjaro, we craft every itinerary by hand and guide it ourselves —
          so the only thing you plan is what to feel next.
        </p>
      </div>
      <div class="stat-grid">
        <div
          v-for="(s, i) in STATS"
          :key="s.label"
          class="stat-cell"
          v-reveal
          :style="{ transitionDelay: i * 90 + 'ms' }"
        >
          <CountUp :to="s.to" :suffix="s.suffix" />
          <span class="gm-stat__label gm-stat__label--light">{{ s.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
